
import React from 'react';
import Footer from '@/components/Footer';

const About = () => {
  return (
    <div className="min-h-screen bg-softwhite">
      <div className="pt-32 pb-16 px-4 max-w-7xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-8">About GoldCrusade</h1>
        <p className="text-xl mb-12">We're on a mission to help businesses achieve their full potential through strategic planning and AI-powered solutions.</p>
        
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div>
            <h2 className="text-3xl font-bold mb-6">Our Story</h2>
            <p className="mb-4">Founded in 2020, GoldCrusade emerged from a simple idea: businesses deserve better strategic partnerships. Our team of experts combines deep industry knowledge with cutting-edge AI technology to deliver exceptional results.</p>
            <p>Today, we serve clients across various industries, helping them navigate challenges and seize opportunities in an ever-changing business landscape.</p>
          </div>
          <div className="bg-goldcore/10 rounded-xl p-8">
            <h2 className="text-3xl font-bold mb-6">Our Values</h2>
            <ul className="space-y-4">
              <li className="flex items-start">
                <span className="font-bold mr-2">Innovation:</span> We constantly explore new ideas and approaches to solve complex business challenges.
              </li>
              <li className="flex items-start">
                <span className="font-bold mr-2">Excellence:</span> We strive for excellence in everything we do, from client service to technical solutions.
              </li>
              <li className="flex items-start">
                <span className="font-bold mr-2">Integrity:</span> We maintain the highest ethical standards and build relationships based on trust.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
